import {
  Badge,
  BenefitList,
  Card,
  HiddenBenefitList,
  HiddenBenefitWrapper,
  Image,
  ImageWrapper,
  Line,
  MintInfo,
  Star,
  SubjectWrapper,
  Title,
} from './BenefitItem.styled';
import { useCallback, useEffect, useRef } from 'react';
import anime from 'animejs';
import { Fade } from 'react-awesome-reveal';

type Props = {
  mintInfo: string;
  rarity: string;
  color: string;
  benefits: string[];
  badgeImage: string;
  image: string;
  size: number;
  hidden?: boolean;
};

const BenefitItem = ({
  mintInfo,
  rarity,
  color,
  benefits,
  badgeImage,
  image,
  size,
  hidden,
}: Props) => {
  const benefitList = benefits.map((item, i) => (
    <li key={String(i)}>{item}</li>
  ));
  return (
    <Card color={color}>
      {rarity === 'GOLD' ? (
        <>
          <Star
            src='/images/star.png'
            top={-60}
            left={220}
            glowStart={100}
            size={31}
          />
          <Star
            src='/images/star.png'
            top={-70}
            left={205}
            glowStart={800}
            size={21}
          />
        </>
      ) : (
        ''
      )}
      <Badge src={badgeImage} />
      <ImageWrapper>
        <Image src={image} size={size} />
      </ImageWrapper>
      <SubjectWrapper>
        <MintInfo>{mintInfo}</MintInfo>
        <Title>{rarity}</Title>
      </SubjectWrapper>
      <Line />
      <BenefitList>{benefitList}</BenefitList>
      {hidden ? (
        <Fade delay={2000} triggerOnce>
          <HiddenBenefitWrapper>
            <HiddenBenefitList>
              <li>편의점 모바일 상품권 5,000원 (매월)</li>
              <li>온라인 쇼핑 무료 배송(월 1회)</li>
              <li>카쉐어링 50% 할인 쿠폰(월 1회)</li>
            </HiddenBenefitList>
          </HiddenBenefitWrapper>
        </Fade>
      ) : (
        ''
      )}
    </Card>
  );
};

export default BenefitItem;
